import { useState, useEffect } from "react";
import axiosInstance from "../../../../Utils/axiosInstance";
import { emptyData, buildDashboardData } from "./utils";

export const useEDADashboard = (locationState) => {
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedDate, setSelectedDate] = useState("all");
  const [selectedComponent, setSelectedComponent] = useState("all");
  const [selectedPlant, setSelectedPlant] = useState("all");
  const [selectedGrouping, setSelectedGrouping] = useState("all");
  const [searchQuery, setSearchQuery] = useState("");

  const [yearsList, setYearsList] = useState([]);
  const [monthsList, setMonthsList] = useState([]);
  const [mondaysList, setMondaysList] = useState([]);
  const [componentsList, setComponentsList] = useState([]);
  const [plantsList, setPlantsList] = useState([]);
  const [groupingsList, setGroupingsList] = useState([]);

  const [dashboardData, setDashboardData] = useState(emptyData);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Fetch Dropdowns
  useEffect(() => {
    const fetchDropdowns = async () => {
      try {
        const response = await axiosInstance.get("Inventory/drop-down");
        if (response?.data?.status && response?.data?.items) {
          const { year, month, monday, component, Plnt, grouping } = response.data.items;

          setYearsList(year || []);
          setMonthsList(month || []);
          setMondaysList(monday || []);
          setComponentsList(component || []);
          setPlantsList(Plnt || []);
          setGroupingsList(grouping || []);

          if (year && year.length > 0) setSelectedYear(year[0].Year);
          if (month && month.length > 0) setSelectedMonth(month[0].Month_No);
          if (monday && monday.length > 0) setSelectedDate(monday[0].Monday_Date === "All Monday" ? "all" : monday[0].Monday_Date);
        }
      } catch (err) {
        console.error("Failed to fetch Inventory dropdown list", err);
      }
    };
    fetchDropdowns();
  }, []);

  // Fetch Dashboard Data
  useEffect(() => {
    if (!locationState) return;
    if (!selectedYear || !selectedMonth) return;

    let ignore = false;

    const fetchData = async () => {
      setLoading(true);
      setError("");
      try {
        const response = await axiosInstance.post("Inventory/dashboard", {
          year: selectedYear,
          month: selectedMonth,
          monday: selectedDate === "all" ? "All Monday" : selectedDate,
          component: selectedComponent === "all" ? "" : selectedComponent,
          Plnt: selectedPlant === "all" ? "" : selectedPlant,
          grouping: selectedGrouping === "all" ? "" : selectedGrouping,
          search: searchQuery
        });

        if (!ignore && response?.data?.status && response?.data?.items) {
          setDashboardData(buildDashboardData(response.data.items));
        }
      } catch (apiError) {
        if (!ignore) {
          setError(apiError?.response?.data?.message || "Failed to fetch MB52 data.");
        }
      } finally {
        if (!ignore) setLoading(false);
      }
    };

    const timerId = setTimeout(() => {
      fetchData();
    }, 300);

    return () => {
      ignore = true;
      clearTimeout(timerId);
    };
  }, [
    locationState,
    selectedYear,
    selectedMonth,
    selectedDate,
    selectedComponent,
    selectedPlant,
    selectedGrouping,
    searchQuery
  ]);

  const handleReset = () => {
    if (yearsList.length > 0) setSelectedYear(yearsList[0].Year);
    if (monthsList.length > 0) setSelectedMonth(monthsList[0].Month_No);
    setSelectedDate("all");
    setSelectedComponent("all");
    setSelectedPlant("all");
    setSelectedGrouping("all");
    setSearchQuery("");
  };

  return {
    filters: {
      selectedYear, setSelectedYear,
      selectedMonth, setSelectedMonth,
      selectedDate, setSelectedDate,
      selectedComponent, setSelectedComponent,
      selectedPlant, setSelectedPlant,
      selectedGrouping, setSelectedGrouping,
      searchQuery, setSearchQuery
    },
    lists: {
      yearsList,
      monthsList,
      mondaysList,
      componentsList,
      plantsList,
      groupingsList
    },
    dashboardData,
    loading,
    error,
    handleReset
  };
};
